// TODO: Main.tsx component separate from App.tsx and App will be the main entry point

import './App.css'
import { useRef, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Routes, Route, BrowserRouter, useNavigate } from 'react-router-dom'
import { MantineProvider } from '@mantine/core'
import { theme } from './utils/theme.util'

import LogIn from './pages/Login'
import Admin_Pickup from './pages/Admin_Pickup'

import Booking from './components/Booking'
import MainInfo from './components/MainInfo'
import HowItWorks from './components/HowItWorks'

import ServiceInfo from './components/ServiceInfo'
import PriceInfo from './components/PriceInfo'
import Footer from './components/Footer'

const queryClient = new QueryClient()

function HomePage() {
  const toTopRef = useRef<HTMLDivElement>(null)
  const toBookingRef = useRef<HTMLDivElement>(null)
  const toHowItWorksRef = useRef<HTMLDivElement>(null)

  const toServiceInfoRef = useRef<HTMLDivElement>(null)
  const toPriceInfoRef = useRef<HTMLDivElement>(null)
  const toFooterRef = useRef<HTMLDivElement>(null)

  const navigate = useNavigate()
  const [clickCount, setClickCount] = useState(0)
  const [lastClickTime, setLastClickTime] = useState(0)
  const [isMenuExpanded, setIsMenuExpanded] = useState(false)

  const scrollToElement = (ref: React.RefObject<HTMLDivElement | null>) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' })
      setIsMenuExpanded(false)
    }
  }

  const handleTitleClick = () => {
    const currentTime = Date.now()

    if (currentTime - lastClickTime < 3000) {
      const newCount = clickCount + 1
      setClickCount(newCount)

      if (newCount === 5) {
        navigate('/login')
        setClickCount(0)
      }
    } else {
      setClickCount(1)
    }

    setLastClickTime(currentTime)
  }

  const toggleMenu = () => {
    setIsMenuExpanded(!isMenuExpanded)
  }

  return (
    <div className='App'>
      <header className='App-header'>
        <div className='App-titles'>
          <p className='App-title' onClick={handleTitleClick}>
            Canadian Laundry
          </p>
          <p className='App-subtitle'>Proudly serving the community since 1987 </p>
        </div>
        <button className='hamburger-menu' onClick={toggleMenu}>
          ☰
        </button>
        <div className={`App-nav ${isMenuExpanded ? 'expanded' : ''}`}>
          <button onClick={() => scrollToElement(toBookingRef)}>Start Booking!</button>
          <button onClick={() => scrollToElement(toHowItWorksRef)}>How It Works?</button>
          <button onClick={() => scrollToElement(toPriceInfoRef)}>Price</button>

          <button onClick={() => scrollToElement(toServiceInfoRef)}>Our Service</button>
          <button onClick={() => scrollToElement(toFooterRef)}>Contact</button>
        </div>
      </header>
      <main className='App-mainContents' ref={toBookingRef}>
        <section className='App-booking'>
          <div className='booking-container'>
            <MainInfo />
            <Booking />
          </div>
        </section>
        <section className='App-HowItWorks' ref={toHowItWorksRef}>
          <HowItWorks />
        </section>
        <section className='App-PriceInfo' ref={toPriceInfoRef}>
          <PriceInfo />
        </section>
        <section className='App-ServiceInfo' ref={toServiceInfoRef}>
          <ServiceInfo />
        </section>
      </main>
      <button className='App-top-button' onClick={() => scrollToElement(toBookingRef)}>
        Top
      </button>
      <footer className='App-footer' ref={toFooterRef}>
        <Footer />
      </footer>
    </div>
  )
}

function App() {
  return (
    <MantineProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/login' element={<LogIn />} />
            <Route path='/admin_pickup' element={<Admin_Pickup />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  )
}

export default App
